import { CFTokens } from '../../../tokens';
export const BACKGROUND_BLUR = CFTokens.BACKGROUND_BLUR_SIZE;
export const HEX_OPACITY = 18;
